<template>
<div id="billing-order-page-scoped-container">
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-sm">
            <div v-if="nmInterface === 'gravar'" class="crud-title">
              <translate>NEW_REGISTRATION</translate>
            </div>
            <div v-else-if="nmInterface === 'alterar'" class="crud-title">
              <translate>REBILL_ORDER</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-px-lg">
            <span v-if="elements.length == 1">
              <jt-dynamic-form
                ref="dynamicForm"
                :inputs="prepareInputs(elements[0].inputs)"
                :relacionamentos="elements[0].relacionamentos"
                :model="elements[0].dadosForm"
                :interface="elements[0].nmInterface"
                form-class="form dynamic"
                @search-found="selections"
                @composition-button-click="onCompositionButtonClick"
              />
              <label class="total-value">TOTAL {{totalValue()}}</label>
            </span>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div
      v-if="forms[0] && forms[0].buttons.length > 0"
      class="row full-width q-col-gutter-lg justify-center q-pt-lg"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :class="{'bt-cancelar': button.name === 'btCancelarAlterar' }"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn
          class="full-width"
          color="info"
          @click="
            () => {
              actionButton(button);
            }
          "
        >
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
    <billing-order-item
      v-if="billingOrderItemShow"
      ref="billingOrderItemModal"
      :form="billingOrderItemForm"
      :composicaos="billingOrderItemData"
      :nr-linha-selecionada="billingOrderItemForm.nrLinhaSelecionada"
      :fl-composicao-alteracao="editMode"
      @onAddSuccess="onAddBillingOrderItemSuccessHandler"
      @onEditSuccess="onEditBillingOrderItemSuccessHandler"
    />
  </div>
</div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
import { repository } from 'jtech'
import BillingOrderItem from './BillingOrderItem.vue'
import { removeSpecialCharacters } from './textUtils'

const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'BillingOrderPage',
  components: { JtDynamicForm, page, BillingOrderItem },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class BillingOrderPage extends Vue {
  nmInterface = null;
  editMode = false;
  billingOrderItemForm = {};
  billingOrderItemData = [];
  billingOrderItemShow = false;
  customCompositions = ['billingOrderItems'];

  mounted () {
    this.nmInterface = this.elements[0].nmInterface.split('.')[1]
    this.elements[0].inputs
      .find((i) => String(i.name).includes('composicao'))
      .columns.splice(4, 1)
    delete this.elements[0].dadosForm.orderWeights
  }

  onFormButtonClick ({ button, fields }) {
    if (button.name) {

    } else {
      this.$emit('form-button-click', { cardKey: this.cardKey, button, form: fields })
    }
  }

  limparForm () {
    this.forms[0].dadosForm = {
      automatic: false,
      available: true,
      billingOrderItems: [],
      manualChange: false
    }
    delete this.forms[0].relacionamentos.serviceCostCenter
  }

  toFixed (number) {
    const arrayChar = number.toString().split('')
    arrayChar.splice((arrayChar.length - 2), 0, '.')

    return Number(arrayChar.join(''))
  }

  totalValue () {
    const billingOrderItems = [...this.elements[0].dadosForm.billingOrderItems]
    let total = Number(0)
    billingOrderItems.forEach(billingOrderItem => {
      if (typeof billingOrderItem.value == 'string') {
        total += this.toFixed(Number(billingOrderItem.value.replace(',', '').replace('.', '')))
      } else {
        total += billingOrderItem.value
      }
    })

    return total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  }

  async selections (data) {
    const { client, available } = this.elements[0].dadosForm
    if (data.client.idField) {
      const param = { id: data.client.idField }
      const { registros } = await repository.resolveDatatableModel(
        'billingOrder.clientAddress',
        param
      )
      this.$refs.dynamicForm.selectAjaxHandler({
        nmAtributo: 'client',
        value: data.client.idField,
        nmInterface: 'billingOrder.gravar'
      })
      delete registros[0].id
      delete registros[0].idAcaoGrid
      this.elements[0].dadosForm = {
        ...this.elements[0].dadosForm,
        ...registros[0]
      }
    } else {
      this.limparForm()
    }
  }

  onCompositionButtonClick (eventObject) {
    const { button: clickedButton } = eventObject

    const { compositionId, formConfig } = eventObject

    switch (clickedButton.name) {
      case 'icAdicionarComposicao':
        this.newBillingOrderItem(formConfig)
        break
      case 'icAlterarComposicao':
        this.editBillingOrderItem(formConfig)
        break
      default:
        break
    }
  }

  prepareInputs (inputs) {
    this.prepareCompositionsInputs(inputs)
    return inputs
  }

  prepareCompositionsInputs (inputs) {
    inputs.forEach((input) => {
      if (this.customCompositions.includes(input.model)) {
        input.allowCustomEditModal = true
      }
    })
  }

  newBillingOrderItem (data) {
    this.editMode = false
    this.openBillingOrderItem(data)
  }

  editBillingOrderItem (data) {
    this.editMode = true
    this.openBillingOrderItem(data)
  }

  openBillingOrderItem (data) {
    this.billingOrderItemShow = true
    this.billingOrderItemForm = JSON.parse(JSON.stringify(data))
    this.billingOrderItemData = [...this.elements[0].dadosForm.billingOrderItems]
    this.$nextTick(() => {
      this.$refs.billingOrderItemModal.show()
    })
  }

  onAddBillingOrderItemSuccessHandler (dados) {
    const registeredProductItem = this.elements[0].dadosForm.billingOrderItems.find(item => item.product == dados.product &&
        item.price == dados.price)
    try {
      if (registeredProductItem) {
        const oldItemValue = this.toFixed(Number(registeredProductItem.value.replace(',', '').replace('.', '')))
        const newItemValue = this.toFixed(Number(dados.value.replace(',', '').replace('.', '')))

        const oldItemQuantity = this.toFixed(Number(registeredProductItem.quantity.replace(',', '').replace('.', '')))
        const newItemQuantity = this.toFixed(Number(dados.quantity.replace(',', '').replace('.', '')))

        registeredProductItem.value = (oldItemValue + newItemValue).toFixed(2)
        registeredProductItem.quantity = (oldItemQuantity + newItemQuantity).toFixed(2)
        this.$refs.billingOrderItemModal.hide()
        this.billingOrderItemShow = true
      } else {
        this.elements[0].dadosForm.billingOrderItems.push(dados)
        this.$refs.billingOrderItemModal.hide()
        this.billingOrderItemShow = true
      }
    } catch (error) {
      console.error('onAddBillingOrderItemSuccessHandler', error)
    }
  }

  onEditBillingOrderItemSuccessHandler (dados) {
    try {
      const index = dados.nrLinhaSelecionada
      Object.assign(this.elements[0].dadosForm.billingOrderItems[index], dados)
      this.$refs.billingOrderItemModal.hide()
      this.billingOrderItemShow = true
    } catch (error) {
      console.error('onEditBillingOrderItemSuccessHandler', error)
    }
  }

  get observationInvoice () {
    return this.elements[0].dadosForm.observationInvoice
  }

  @Watch('observationInvoice')
  onObservationInvoiceChange (newVal) {
    this.elements[0].dadosForm.observationInvoice = removeSpecialCharacters(newVal)
  }
}
export default BillingOrderPage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
.total-value {
  display:flex;
  justify-content: flex-end;
  margin-top:10px;
  margin-right:20px;
  font-weight:bold;
  color:#3c4255
}
#billing-order-page-scoped-container{
  .bt-cancelar{
    .bg-info{
      background-color:#830119 !important;
    }
  }
}
</style>
